(function() {
var forum = require('./forum.js');
var dom = require('./dom.js'), doc=dom.doc;

doc.id("genbug"    ).onclick = forum.genbug;
doc.id("genfeature").onclick = forum.genfeature;

var gotd = require('./gotd.js');
gotd.init(window.__gotd.gotd, window.__gotd.seed_chain);

doc.id("unwelcome").onclick = function() { doc.id("welcome").classList.add("animated", "fadeOutDown") }
})()(function() {
var forum = require('./forum.js');
var dom = require('./dom.js'), doc=dom.doc;

doc.id("genbug"    ).onclick = forum.genbug;
doc.id("genfeature").onclick = forum.genfeature;

var gotd = require('./gotd.js');
gotd.init(window.__gotd.gotd, window.__gotd.seed_chain);

doc.id("unwelcome").onclick = function() { doc.id("welcome").classList.add("animated", "fadeOutDown") }
})()